/* LEXUP — animations. Aucune dépendance. */
(function(){
  var q=function(s,r){return Array.prototype.slice.call((r||document).querySelectorAll(s));};

  function reveals(){
    if(!('IntersectionObserver' in window)) return;
    var io=new IntersectionObserver(function(es){
      es.forEach(function(e){
        if(!e.isIntersecting) return;
        var el=e.target;
        if(el.getAttribute('data-lx-init')==='done') return;
        el.setAttribute('data-lx-init','done');
        var d=parseInt(el.getAttribute('data-lx-delay')||'0',10);
        el.style.animation='lxRise .8s cubic-bezier(.22,1,.36,1) '+d+'ms both';
        io.unobserve(el);
      });
    },{rootMargin:'0px 0px 10% 0px',threshold:.02});
    q('[data-lx-reveal]').forEach(function(el){ io.observe(el); });
  }

  function counters(){
    q('[data-lx-count]').forEach(function(el){
      if(el.getAttribute('data-lx-done'))return; el.setAttribute('data-lx-done','1');
      var t=parseInt(el.getAttribute('data-lx-count')||'0',10),t0=performance.now();
      (function tick(n){var p=Math.min(1,(n-t0)/1100);el.textContent=Math.round(t*(1-Math.pow(1-p,3)));if(p<1)requestAnimationFrame(tick);})(t0);
    });
    q('[data-lx-num]').forEach(function(el){
      if(el.getAttribute('data-lx-done'))return; el.setAttribute('data-lx-done','1');
      var t=parseFloat(el.getAttribute('data-lx-num')||'0'),t0=performance.now();
      (function tick(n){var p=Math.min(1,(n-t0)/1400);el.textContent=(t*(1-Math.pow(1-p,3))).toFixed(2).replace('.',',');if(p<1)requestAnimationFrame(tick);})(t0);
    });
  }

  function bars(){ setTimeout(function(){ q('[data-lx-bar]').forEach(function(el){ el.style.width=el.getAttribute('data-lx-bar'); }); },600); }

  function achats(){
    var v=window.LEXUP_ACHATS;
    if(!isFinite(v))return;
    q('[data-lx-achats]').forEach(function(el){ el.setAttribute('data-lx-count',v); el.textContent=v; });
    q('[data-lx-jauge]').forEach(function(el){
      var p=parseInt(el.getAttribute('data-lx-palier')||'50',10);
      el.setAttribute('data-lx-bar',Math.min(100,Math.round(v/p*100))+'%');
    });
  }

  /* Défilement de la capture du guide.
     L'observation porte sur le CADRE, pas sur l'image : une capture de page
     entière ne peut jamais atteindre 35 % de visibilité à l'écran. */
  function guide(){
    q('[data-lx-guidescroll]').forEach(function(g){
      if(g.getAttribute('data-lx-guide-init')==='done') return;
      g.setAttribute('data-lx-guide-init','done');
      var box=g.parentElement;
      if(!box) return;
      var visible=false;
      function apply(){
        var over=g.offsetHeight-box.offsetHeight;
        if(!(over>0)){ g.style.transform='translateY(0)'; return; }
        var d=Math.min(over,4000);
        g.style.transitionDuration=Math.max(8,Math.round(d/90))+'s';
        g.style.transform=visible?'translateY(-'+d+'px)':'translateY(0)';
      }
      var img=g.tagName==='IMG'?g:g.querySelector('img');
      if(img&&!img.complete) img.addEventListener('load',apply);
      window.addEventListener('resize',apply,{passive:true});
      if('IntersectionObserver' in window){
        new IntersectionObserver(function(es){
          es.forEach(function(e){ visible=e.isIntersecting; apply(); });
        },{threshold:.25}).observe(box);
      } else { visible=true; apply(); }
      apply();
    });
  }

  function scroller(){
    var bar=document.querySelector('[data-lx-progress]'),hero=document.querySelector('[data-lx-hero]'),
        sticky=document.querySelector('[data-lx-sticky]'),raf=null;
    function frame(){
      raf=null;
      var y=window.scrollY||document.documentElement.scrollTop,
          h=document.documentElement.scrollHeight-window.innerHeight;
      if(bar) bar.style.width=(h>0?(y/h)*100:0)+'%';
      q('[data-lx-parallax]').forEach(function(el){
        var r=el.getBoundingClientRect(),k=parseFloat(el.getAttribute('data-lx-parallax'));
        el.style.transform='translate3d(0,'+((r.top+r.height/2-window.innerHeight/2)*k).toFixed(1)+'px,0)';
      });
      if(sticky&&hero) sticky.classList.toggle('on', y>hero.offsetTop+hero.offsetHeight*0.7);
    }
    window.addEventListener('scroll',function(){ if(!raf) raf=requestAnimationFrame(frame); },{passive:true});
    frame();
  }

  function clock(){
    var c=window.__lxClock;
    if(c) return;
    c=window.__lxClock={t0:performance.now(),lastT:-1,lastS:null,tileLock:0,swLock:0};
    function paintTiles(k){
      var tiles=q('[data-lx-tile]'); if(!tiles.length)return;
      k=((k%tiles.length)+tiles.length)%tiles.length;
      tiles.forEach(function(el,i){
        var on=i===k;
        el.style.background=on?'var(--lx-marine)':'var(--lx-papier)';
        el.style.borderColor=on?'var(--lx-marine)':'var(--lx-filet)';
        el.style.transform=on?'translateY(-8px) scale(1.02)':'none';
        el.style.boxShadow=on?'0 40px 70px -50px rgba(30,58,95,.85)':'none';
        var n=el.querySelector('[data-lx-tnum]'),l=el.querySelector('[data-lx-tlabel]'),
            s=el.querySelector('[data-lx-tsub]'),r=el.querySelector('[data-lx-ring]'),
            rb=el.querySelector('[data-lx-ringbg]'),sw=el.querySelector('.lx-sweep');
        if(n) n.style.color=on?'var(--lx-ivoire)':'var(--lx-marine)';
        if(l) l.style.color=on?'var(--lx-ivoire)':'var(--lx-encre)';
        if(s) s.style.color=on?'var(--lx-marine-clair)':'var(--lx-taupe)';
        if(r){ r.style.stroke=on?'#EDE7DD':'#1e3a5f'; r.setAttribute('stroke-dashoffset',on?'0':'176'); }
        if(rb) rb.setAttribute('stroke',on?'rgba(237,231,221,.28)':'#E0D6C9');
        if(sw){ sw.style.animation='none';
          if(on) requestAnimationFrame(function(){ sw.style.opacity='1'; sw.style.animation='lxSweep 1.5s cubic-bezier(.4,0,.2,1) both'; });
          else sw.style.opacity='0'; }
      });
    }
    function paintSwitch(apres){
      var m=document.querySelector('[data-lx-swmoy]'),g=document.querySelector('[data-lx-swrang]'),
          b=document.querySelector('[data-lx-swbar]');
      if(m){ m.textContent=apres?m.getAttribute('data-apres'):m.getAttribute('data-avant');
             m.style.color=apres?'var(--lx-marine)':'var(--lx-taupe)'; }
      if(g){ g.textContent=apres?g.getAttribute('data-apres'):g.getAttribute('data-avant');
             g.style.color=apres?'var(--lx-encre)':'var(--lx-taupe)'; }
      if(b){ b.style.width=apres?b.getAttribute('data-apres'):b.getAttribute('data-avant');
             b.style.background=apres?'var(--lx-marine)':'var(--lx-taupe)'; }
      q('[data-lx-swpane]').forEach(function(el){
        var on=(el.getAttribute('data-lx-swpane')==='apres')===!!apres;
        el.style.opacity=on?'1':'0';
        el.style.transform=on?'translateY(0)':'translateY(14px)';
        el.style.position=on?'relative':'absolute';
        el.style.pointerEvents=on?'auto':'none';
        el.style.top='0';el.style.left='0';el.style.right='0';
      });
      q('[data-lx-swtab]').forEach(function(el){
        var on=(el.getAttribute('data-lx-swtab')==='1')===!!apres;
        el.style.background=on?'var(--lx-marine)':'transparent';
        el.style.color=on?'var(--lx-ivoire)':'var(--lx-taupe)';
      });
    }
    window.__lxPaintTiles=paintTiles; window.__lxPaintSwitch=paintSwitch;
    setInterval(function(){
      var el=performance.now()-c.t0;
      if(document.querySelector('[data-lx-tile]')&&Date.now()>c.tileLock){
        var tk=Math.floor(el/2400)%(q('[data-lx-tile]').length||1);
        if(tk!==c.lastT){ c.lastT=tk; paintTiles(tk); }
      }
      if(document.querySelector('[data-lx-swmoy]')&&Date.now()>c.swLock){
        var sv=Math.floor(el/4200)%2===1;
        if(sv!==c.lastS){ c.lastS=sv; paintSwitch(sv); }
      }
    },250);
    document.addEventListener('mouseover',function(e){
      var t=e.target.closest&&e.target.closest('[data-lx-tile]');
      if(!t)return;
      var i=q('[data-lx-tile]').indexOf(t);
      c.tileLock=Date.now()+6000; c.lastT=i; paintTiles(i);
    });
    document.addEventListener('click',function(e){
      var t=e.target.closest&&e.target.closest('[data-lx-swtab]');
      if(!t)return;
      var a=t.getAttribute('data-lx-swtab')==='1';
      c.swLock=Date.now()+12000; c.lastS=a; paintSwitch(a);
    });
  }

  function init(){ achats(); reveals(); counters(); bars(); guide(); scroller(); clock(); }
  if(document.readyState!=='loading') init(); else document.addEventListener('DOMContentLoaded',init);
  document.addEventListener('shopify:section:load',function(){ achats(); reveals(); counters(); bars(); guide(); });
})();
